const offersTypes = {
    // Get offers list
    GET_OFFERS_LIST_PENDING: "GET_OFFERS_LIST_PENDING",
    GET_OFFERS_LIST_SUCCESS: "GET_OFFERS_LIST_SUCCESS",
    GET_OFFERS_LIST_ERROR: "GET_OFFERS_LIST_ERROR",

    // Create offer
    CREATE_OFFER_PENDING: "CREATE_OFFER_PENDING",
    CREATE_OFFER_SUCCESS: "CREATE_OFFER_SUCCESS",
    CREATE_OFFER_ERROR: "CREATE_OFFER_ERROR",

    // Get communities
    GET_COMMUNITIES_PENDING: "GET_COMMUNITIES_PENDING",
    GET_COMMUNITIES_SUCCESS: "GET_COMMUNITIES_SUCCESS",
    GET_COMMUNITIES_ERROR: "GET_COMMUNITIES_ERROR",

    // Update offer
    UPDATE_OFFER_PENDING: "UPDATE_OFFER_PENDING",
    UPDATE_OFFER_SUCCESS: "UPDATE_OFFER_SUCCESS",
    UPDATE_OFFER_ERROR: "UPDATE_OFFER_ERROR",

    // Delete offer
    DELETE_OFFER_PENDING: "DELETE_OFFER_PENDING",
    DELETE_OFFER_SUCCESS: "DELETE_OFFER_SUCCESS",
    DELETE_OFFER_ERROR: "DELETE_OFFER_ERROR",

    // Get offer details
    GET_OFFER_DETAILS_PENDING: "GET_OFFER_DETAILS_PENDING",
    GET_OFFER_DETAILS_SUCCESS: "GET_OFFER_DETAILS_SUCCESS",
    GET_OFFER_DETAILS_ERROR: "GET_OFFER_DETAILS_ERROR",

    // Clear current offer
    CLEAR_CURRENT_OFFER: "CLEAR_CURRENT_OFFER",

    // Activate offer
    ACTIVATE_OFFER_PENDING: "ACTIVATE_OFFER_PENDING",
    ACTIVATE_OFFER_SUCCESS: "ACTIVATE_OFFER_SUCCESS",
    ACTIVATE_OFFER_ERROR: "ACTIVATE_OFFER_ERROR",

    // Suspend offer
    SUSPEND_OFFER_PENDING: "SUSPEND_OFFER_PENDING",
    SUSPEND_OFFER_SUCCESS: "SUSPEND_OFFER_SUCCESS",
    SUSPEND_OFFER_ERROR: "SUSPEND_OFFER_ERROR",
};

export default offersTypes;
